import { Alert, type AlertColor } from "@mui/material";
import { type CustomContentProps } from "notistack";
import { useSnackbar } from "notistack";
import { forwardRef } from "react";

export const SnackbarToast = forwardRef<HTMLDivElement, CustomContentProps>((props, ref) => {
  const { id, message, variant, style } = props;
  const alertSeverity: AlertColor = variant === "default" ? "info" : variant;
  const { closeSnackbar } = useSnackbar();
  return (
    <Alert
      ref={ref}
      style={style}
      id={String(id)}
      severity={alertSeverity}
      variant="filled"
      sx={{
        minWidth: {
          xs: "initial",
          md: 600,
        },
      }}
      onClose={() => {
        closeSnackbar(id);
      }}
    >
      {message}
    </Alert>
  );
});

SnackbarToast.displayName = "SnackbarToast";
